export const trans_9_1=[
  {
    id:1,
    english:'What is the weather like in Da Lat today?',
    vietnamese:'Thời tiết ở Đà Lạt hôm nay như thế nào?',
    user_message:''
  },
  {
    id:2,
    english:'What is the weatcher like in winter?',
    vietnamese:'Thời tiết mùa đông như thế nào?',
    user_message:''
  },
  {
    id:3,
    english:'Today, the weatcher is very hot',
    vietnamese:'Hôm nay, thời tiết rất nóng',
    user_message:''
  },
  {
    id:4,
    english:'The sky is very black. It is going to rain',
    vietnamese:'Bầu trời đang đến dần. Trời sắp mưa rồi',
    user_message:''
  }, 

]

export const trans_9_2=[
  {
    id:1,
    english:'Do you like summer in Viet Nam? No, I do not like, beacause it is very hot',
    vietnamese:'Bạn có thích mùa hè ở Việt Nam không? Tôi không thích vì nó rất nóng',
    user_message:''
  },
  {
    id:2,
    english:'There are four seasons in Viet Nam. They are Spring, Summer, Fall and Winter',
    vietnamese:'Ở Việt Nam có bốn mùa: Xuân, Hạ, Thu, Đồng',
    user_message:''
  },
  {
    id:3,
    english:'Which season in viet Nma do you like best?',
    vietnamese:'Bân tích mùa nào ở Việt Nam nhất?',
    user_message:''
  },
  {
    id:4,
    english:'Today, the weatcher forecast says that it is going to rain',
    vietnamese:'Hôm nay dự báo trời sẽ có mưa?',
    user_message:''
  }, 
  {
    id:5,
    english:'I really love the weatcher in Da Lat',
    vietnamese:'Tôi rất thích thời tiết ở Đà Lạt',
    user_message:''
  },  

]